import { Skeleton } from "@/components/shared/Skeleton";

interface SlideStyleSkeletonProps {
  count?: number;
}

export function SlideStyleSkeleton({ count = 6 }: SlideStyleSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={`slide-style-skeleton-${index + 1}`}
          className="relative border-2 border-slate-200 rounded-lg bg-white overflow-hidden"
        >
          {/* Image skeleton */}
          <div style={{ aspectRatio: "9/20" }}>
            <Skeleton className="w-full h-full rounded-t-lg" />
          </div>

          {/* Content skeleton */}
          <div className="flex flex-col items-center justify-center p-3 gap-2">
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        </div>
      ))}
    </>
  );
}
